import React from "react";
import styled from "styled-components";

export default function TwitterDescription() {
  return (
    <ul>
      <ListItem>
        <b>Pokemon Database: </b> The app offers overview of hundreds of
        Pokemon, including their statistics, abilities, types, and many other
        aspects.
      </ListItem>
      <ListItem>
        <b>Pagination and pokemon search bar.</b>
      </ListItem>
      <ListItem>
        <b>Favorites List: </b> Users can add selected Pokemon to their
        favorites list, and the app will display a notification confirming the
        addition.
      </ListItem>
      <ListItem>
        <b>Responsive Design.</b>
      </ListItem>
      <ListItem>
        <b>Pokemon Information Pages:</b> The app also offers detailed
        information page.
      </ListItem>
    </ul>
  );
}

const ListItem = styled.li`
  list-style-type: none;
  margin-bottom: 8px;
`;
